import request from './request.js'

export function getOrganizationTreeData(data) {
  return request({
    url: 'approveorganization/getTreeData',
    method: 'post',
    params: data
  });
}
// approveorganization/getData
export function getOrganization(data) {
  return request({
    url: 'approveorganization/getData',
    method: 'post',
    params: data
  });
}
// 新增树形结构节点
// approveorganization/insert
export function insertOrganization(data) {
  return request({
    url: 'approveorganization/insert',
    method: 'post',
    params: data
  });

}
// approveorganization/delete
export function deleteOrganization(data) {
  return request({
    url: 'approveorganization/delete',
    method: 'post',
    params: data
  });

}

// approveorganization/update
export function updateOrganization(data) {
  return request({
    url: 'approveorganization/update',
    method: 'post',
    params: data
  });
}

// approveorganization/applyInternalTeam
export function applyInternalTeam(data) {
  return request({
    url: 'approveorganization/applyInternalTeam',
    method: 'post',
    params: data
  });
}

// route/getDataWithIfNeed
export function getRouteType(data) {
  return request({
    url: 'route/getDataWithIfNeed',
    method: 'post',
    params: data
  });
}

// route/changeNeedApprove
export function changeNeedApprove(data) {
  return request({
    url: 'route/changeNeedApprove',
    method: 'post',
    params: data
  });
}

// 更换审批人
// /approve/update
export function updateApprover(data) {
  return request({
    url: 'approve/updateBatch',
    method: 'post',
    params: data
  });
}

export function updateRelatedProject(data) {
  return request({
    url: 'approveorganization/updateRelatedProject',
    method: 'post',
    params: data
  });
}

export function approveorganizationGetDataByRoute(data){
  return request({
    url: 'approveorganization/getDataByRoute',
    method: 'post',
    params: data
  });
}
export function agentGetlevel(data){
  return request({
    url: 'agent/getLevel',
    method: 'post',
    params: data
  });
}

export function getChannelApproverData(data){
  return request({
    url: 'channelApprover/getData',
    method: 'post',
    params: data
  });
}

export function insertChannelApprover(data){
  return request({
    url: 'channelApprover/insert',
    method: 'post',
    params: data
  });
}

export function updateChannelApprove(data){
  return request({
    url: 'channelApprove/update',
    method: 'post',
    params: data
  });
}

export function getIncompleteData(data){
  return request({
    url: 'route/getIncompleteData',
    method: 'post',
    params: data
  });
}

export function insertProjectShareApprove(data){
  return request({
    url: 'projectShareApprove/insert',
    method: 'post',
    params: data
  });
}

export function updateProjectShareApprove(data){
  return request({
    url: 'projectShareApprove/update',
    method: 'post',
    params: data
  });
}

export function getProjectShareApprove(data){
  return request({
    url: 'projectShareApprove/getOneData',
    method: 'post',
    params: data
  });
}

export function updateProjectShareApprover(data){
  return request({
    url: 'projectShareApprove/updateApprover',
    method: 'post',
    params: data
  });
}

export function getProjectShareRequest(data){
  return request({
    url: 'projectShareApprove/getRequestData',
    method: 'post',
    params: data
  });
}

export function getOneProjectShareRequest(data){
  return request({
    url: 'projectShareApprove/getOneRequestData',
    method: 'post',
    params: data
  });
}

export function approveShared(data){
  return request({
    url: 'projectShareApprove/approve',
    method: 'post',
    params: data
  });
}

export function shareToTeam(data){
  return request({
    url: 'projectshare/shareToTeam',
    method: 'post',
    params: data
  });
}

export function setReadRequest(data){
  return request({
    url: 'projectShareApprove/setRead',
    method: 'post',
    params: data
  });
}



// WEBPACK FOOTER //
// ./src/api/approveApi.js